import { render, staticRenderFns } from "./sendMltt.vue?vue&type=template&id=23ab0b83"
import script from "./sendMltt.vue?vue&type=script&lang=js"
export * from "./sendMltt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports